<template>
  <div>
    <transition-group name="fade">
      <div
        class="selection-wrapper"
        v-for="(level, index) in getLevels"
        :key="index">
        <grid-row column-align="left" col-spaced>
          <grid-col col-size="3">
            <label-input
              type="Number"
              ref="duration"
              form-size="m"
              :label="getLabelText"
              :margin="false"
              :value="level.value.toString()"
              v-on:input="(value) => {level.value = value}"
              required/>
          </grid-col>
          <grid-col col-size="1" class="center-wrapper">
            <font-awesome-icon
              :class="isRemoveButtonDisabled(index) ? 'selection-right-disabled' : 'selection-right'"
              v-on:click="onClickRemoveLevel(index)"
              :hidden="isRemoveButtonDisabled(index)"
              :icon="icon.remove"/>
          </grid-col>
        </grid-row>
      </div>
    </transition-group>

    <div
      class="add-wrapper">
      <btn-pill
        :disabled="isAddButtonDisabled()"
        v-on:click="onClickAddLevel()"
        btn-size="s"
        btn-type="secondary">
        <font-awesome-icon :icon="icon.add"/>
        {{ $t('health.challenge.addLevel') }}
      </btn-pill>
    </div>
  </div>
</template>

<script>

import BtnPill from '@/components/shared/buttons/BtnPill';
import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
import LabelInput from '@/components/shared/forms/LabelInput';
import {faPlusCircle, faTimesCircle} from '@fortawesome/pro-solid-svg-icons';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';

export default {
  name: 'ChallengeLevelsForm',
  components: {
    FontAwesomeIcon,
    BtnPill,
    LabelInput,
    GridCol,
    GridRow
  },
  data () {
    return {
      levels: [],
      labelText: '',
      icon: {
        add: faPlusCircle,
        remove: faTimesCircle
      }
    };
  },
  props: {
    mode: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    getLevels () {
      return this.levels;
    },
    getLabelText () {
      return this.labelText;
    },
    isAccumulatedMode () {
      return this.mode != null && this.mode.id === 0;
    },
    isStreakMode () {
      return this.mode != null && this.mode.id === 1;
    }
  },
  watch: {
    mode () {
      if (this.isAccumulatedMode) {
        this.labelText = this.$t('health.challenge.accumulatedValue');
      } else if (this.isStreakMode) {
        this.labelText = this.$t('health.challenge.streakDays');
      } else {
        this.labelText = this.$t('health.challenge.fulfillingDays');
      }
    },
    levels () {
      this.updateModel();
    }
  },
  methods: {
    isAddButtonDisabled () {
      let disabled = false;
      return disabled;
    },
    onClickAddLevel () {
      const order = this.levels.length;
      const level = {
        order: order,
        value: 0
      };
      this.levels.push(level);
    },
    isRemoveButtonDisabled (index) {
      // At least one variable
      return this.levels.length === 1 || index <= 0;
    },
    onClickRemoveLevel (index) {
      if (!this.isRemoveButtonDisabled(index)) {
        this.levels.splice(index, 1);
      }
    },
    updateModel () {
      this.$emit('input', this.levels);
    }
  }

};
</script>

<style lang="scss" scoped>
@import "src/stylesheets/variables";

.center-wrapper {
  display: flex;
  align-items: center;
}

.selection-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: $sp-margin-small;
}

.selection-right {
  font-size: $fs-xl;
  cursor: pointer;
  color: $primary;
}

.selection-right-disabled {
  font-size: $fs-xl;
  color: $primary;
}

</style>



// WEBPACK FOOTER //
// src/brand/health/components/challenge/ChallengeLevelsForm.vue